<template>
  <button
    class="btn"
    type="button"
    data-bs-toggle="offcanvas"
    data-bs-target="#offcanvasDevSidebar"
    aria-controls="offcanvasDevSidebar"
    id="dev-sidebar-toggler"
    v-if="APP_ENV === 'development'"
  >
    <i class="fas fa-chevron-left"></i>
  </button>

  <div
    class="offcanvas offcanvas-end"
    tabindex="-1"
    id="offcanvasDevSidebar"
    aria-labelledby="offcanvasDevSidebarLabel"
    v-if="APP_ENV === 'development'"
  >
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasDevSidebarLabel">
        Developer tools
      </h5>
      <button
        type="button"
        class="btn-close text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <div class="offcanvas-body">
      <button
        class="button"
        type="button"
        @click="completeCurrentExercise"
        data-bs-dismiss="offcanvas"
      >
        Complete current exercise
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DevSidebar",
  data() {
    return {
      APP_ENV: import.meta.env.MODE,
    };
  },
  methods: {
    completeCurrentExercise() {
      // Use store param value change as trigger
      this.$store.commit("exercises/SET_AUTORESOLVE", true);
      this.$nextTick(() => {
        this.$store.commit("exercises/SET_AUTORESOLVE", false);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#dev-sidebar-toggler {
  position: fixed;
  right: 0;
  top: 15%;
  border-radius: 5px 0 0 5px;
  border: 3px solid $tertiaryBorderColor;
  background-color: $tertiaryColor;
}

.offcanvas-body {
  display: flex;
  flex-direction: column;

  .button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 10px;
    border: 3px solid #f284cd;
    background-color: #f284cd;
    color: white;
    height: 45px;
    border-radius: 15px;
    font-weight: bold;

    &:hover {
      border: 3px solid #f284cd;
      color: #f284cd;
      background-color: #fff;
    }
  }
}
</style>
